import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Button, Icon } from "react-materialize";
import { withTranslation } from 'react-i18next';
import { compose } from "redux";

import PropTypes from "prop-types";
import { connect } from "react-redux";

import PalletConfigurationForm from "./form/palletConfigurationForm";
import EditCameraModel from "./form/editCameraModel";
import AddCameraModel from "./form/addCameraModel";
import DeleteCameraModel from "./form/deleteCameraModel";
import cameraModelApi from "../../api/cameraModelApi";
import cmConfigApi from "../../api/cmConfig";
import ButtonFactory from "../../components/material/ButtonFactory";
import ReactTableBuilder from "../../utils/reactTableBuilder";
import ModalFactory from "../../components/modal/ModalFactory";
import { expeditionType } from "../../actions/staticDataList";

function Camera (props) {
  const { t } = props;

  const [cameraModels, setCameraModels] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showDel, setShowDel] = useState(false);
  const [idClicked, setIdClicked] = useState("");
  const [editInfo, setEditInfo] = useState();
  const [paletConfigOpened, setPaletConfigOpened] = useState(false);
  const [showConfirmRemovePalletConfigLine, setShowConfirmRemovePalletConfigLine] = useState(false);
  const [palletConfigIndexToRemove, setPalletConfigIndexToRemove] = useState();
  const [palletConfigFormObjet, setPalletConfigFormObjet] = useState({});
  const [showNewPalletConfig, setShowNewPalletConfig] = useState(false);
  const  [cmList, setCmList] = useState([]);

  useEffect(()=>{
    cmConfigApi.getCmConfigs().then((res) => {
      res.data.unshift({
        name: "All",
        netsuiteInternalId: "0",
      });
      setCmList(res.data);
    });
    
  },[]);

   useEffect(() => {
    cameraModelApi.getCameraModels()
    .then(res => {
      res.data.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
      setCameraModels(res.data);
    })
    .catch(
    );
  }, [showDel, showAdd, showEdit]);

  function showEditWindow (e) {
    setIdClicked(e.target.id);
    cameraModelApi.getCameraModel(e.target.id)
    .then(res => {
      setEditInfo(res.data);
      setShowEdit(!showEdit);
    })
    .catch(err =>
      console.log("error : " + err)
    );
  };

  function showDeleteWindow(e) {
    setIdClicked(e.target.id);
    setShowDel(!showDel);
  }

  function showAddWindow() {
    setShowAdd(!showAdd);
  }

  function handleDelClose() {
    setShowDel(false);
  }
  function handleAddClose() {
    setShowAdd(false);
  }
  function handleEditClose() {
    setShowEdit(false);
  }

  function showPaletConfig(e){
    setIdClicked(e.target.id);
    cameraModelApi.getCameraModel(e.target.id)
    .then(res => {
      console.log(res.data)
      setEditInfo(res.data);
      setPaletConfigOpened(true);
    })
    .catch(err =>
      console.log("error : " + err)
    );
  }

  function closePaletConfig() {
    setPaletConfigOpened(false);
  }

  function makeTable() {
    return cameraModels.map((item, key) =>
    <tr key={item.id}>
      <td>{item.name}</td>
      <td><ButtonFactory name={item.name} icon='edit' onClick={showEditWindow}/></td>
      <td><ButtonFactory name={item.name} icon='pallet' onClick={showPaletConfig}/></td>
      <td><ButtonFactory name={item.name} icon='delete' onClick={showDeleteWindow}/></td>
    </tr>)
  }

  function openConfirmRemovePalletConfigLine(e)
  {
    let button = e.target;
    if(button.localName==="i")
      button= button.parentElement; 

    setPalletConfigIndexToRemove(button.value);
    setShowConfirmRemovePalletConfigLine(true);
  }

  function removePalletConfiguration() {
    editInfo.palletConfigurations.splice(palletConfigIndexToRemove, 1);
    setShowConfirmRemovePalletConfigLine(false);
  }

  function closeConfirmRemovePalletConfigLine(){
    setShowConfirmRemovePalletConfigLine(false);
  }

  function showNewPalletConfiguration(e) {
    let button = e.target;
    if(button.localName==="i")
      button= button.parentElement;

    let palletConfigurationInfo = {
        index:-1,
        affectedCm: "0",
        expeditionType: '',
        totalUnits: '',
        unitsPerMasterpack: ''
      }

    if(button.name === "edit") {
      palletConfigurationInfo = editInfo.palletConfigurations[button.value]
      palletConfigurationInfo.index = button.value;
    }

    setPalletConfigFormObjet(palletConfigurationInfo);
    setShowNewPalletConfig(true);
    setPaletConfigOpened(false)
  }

  function closeNewPalletConfiguration() {
    setShowNewPalletConfig(false);
    setPaletConfigOpened(true)
  }

  function onSavePalletConfiguration(data){
    const cameraModel = editInfo;

    const palletConfiguration={
      affectedCm: data.affectedCm,
      expeditionType: data.expeditionType,
      totalUnits: data.totalUnits,
      unitsPerMasterpack: data.unitsPerMasterpack
    };

    if(!cameraModel.palletConfigurations)
      cameraModel.palletConfigurations=[];

    if(data.index === -1)
      cameraModel.palletConfigurations.push(palletConfiguration);
    else
      cameraModel.palletConfigurations[data.index]=palletConfiguration;

      setEditInfo(cameraModel);
  }

  function PalletConfigurationModal(){
    
    function submitChanges(){
      const cameraModel= {
        name: editInfo.name,
        commonName: editInfo.commonName,
        barcode: editInfo.barcode,
        masterPackDescription: editInfo.masterPackDescription,
        nameSufix: editInfo.nameSufix,
        year: parseInt(editInfo.year),
        active: editInfo.active,
        masterPackOnly: editInfo.masterPackOnly,
        productCode: editInfo.productCode,
        productCodeLinked: editInfo.productCodeLinked,
        numberByPack: editInfo.numberByPack,
        isPack: editInfo.isPack,
        palletConfigurations:editInfo.palletConfigurations
      }

      cameraModelApi.putCameraModel(cameraModel)
      .then(res => {
        closePaletConfig();
        document.body.style.overflow = 'auto';
      })
      .catch(err => {
        const errors = err.response ? err.response.data : err;
        console.log(errors)
      });
    }

    const columns =[
      {
        Header: t("pallet_configuration.affected_cm"),
        accessor:(row) =>{
          return cmList.find(cm => cm.netsuiteInternalId === row.affectedCm)?.name || row.affectedCm
        },
      },
      {
        Header: t("pallet_configuration.expedition_type"),
        accessor: "expeditionType",
      },
      {
        Header: t("pallet_configuration.total_units"),
        accessor: "totalUnits",
      },
      {
        Header: t("pallet_configuration.units_by_masterpack"),
        accessor: "unitsPerMasterpack",
      },
      {
        Header: t("pallet_configuration.total_masterpacks"),
        accessor: (row)=>{
          return row.totalUnits/row.unitsPerMasterpack;
        },
      },
      {
        Header: t("Action"),
        accessor: (row, index)=>{
          return (<>
            <Col><Button name={"edit"} value={index} onClick={showNewPalletConfiguration}><Icon>edit</Icon></Button></Col>
            <Col><Button name={"remove"} value={index}  onClick={openConfirmRemovePalletConfigLine}><Icon>delete</Icon></Button></Col>
          </>);
        },
      },
    ]

    return (
      <>
        <PalletConfigurationForm formLists={{expeditionType, cmList}}isOpen={showNewPalletConfig} item={palletConfigFormObjet} onClose={closeNewPalletConfiguration} onSave={onSavePalletConfiguration}/>
        <Modal
          open={paletConfigOpened}
          header={editInfo?.name ?? "N/A"}
          options={{
            onCloseStart: closePaletConfig,
          }}
          className="large-modal"
          actions={(
          <>
           <Button onClick={submitChanges}>Save</Button>
           <Button modal="close" style={{ marginLeft:'5px',backgroundColor:'#a3a3a3d1'}}>Close</Button>
          </>)}
        >
          <Row><Button name={"create"} onClick={showNewPalletConfiguration}>New configuration</Button><br /></Row>
          <Row>
            <ReactTableBuilder  columns={columns}
                  data={editInfo?.palletConfigurations ?? []}/>
          </Row>
          
          <ModalFactory modalMode="modalYesNo" buttonSaveText={t('delete')} 
                      buttonCancelText={t('cancel')} 
                      onClickSave={removePalletConfiguration} 
                      onClickCancel={closeConfirmRemovePalletConfigLine}
                      show={showConfirmRemovePalletConfigLine} 
                      title={t('input.delete_confirmation')} 
                      paragraph={t('pallet_configuration.removePalletConfiguration')} />
        </Modal>
      </>);
  }

    return (
      <div>
        <div>
          <div style={{ marginTop: "30px"}} className="container">
            {showEdit === true &&
              <EditCameraModel
                nameCamera={idClicked}
                model={editInfo}
                cameraModels={cameraModels}
                onClose={handleEditClose}
              />
            }
            {showAdd === true &&
              <AddCameraModel 
                onClose={handleAddClose}
              />
            }
            {showDel === true &&
              <DeleteCameraModel
                delCameraModel={idClicked}
                onClose={handleDelClose}
              />
            }
            <Row>
              <Col s={1}>
                <div className="row">
                  	<ButtonFactory href="#/settings" icon='arrow_back' />
                </div>
              </Col>
              <Col s={12} m={2} >
              </Col>
              <Col s={12} m={6} >
                <h4> {t('setting.camera_maintenance')}</h4>
              </Col>
            </Row>
            <div>
              <ButtonFactory isLargeIcon={true} name="add" icon='add' onClick={showAddWindow}/>
            </div>
            <table style={{ marginTop: "25px" }} >
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2" }}>
                  <td>{t('setting.camera_name')}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {makeTable()}
              </tbody>
            </table>
          </div>
        </div>
        <PalletConfigurationModal />
      </div>
    );       
}

Camera.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(Camera);
